import CryptoJS from "crypto-js";
import { key } from "./Urls";
import { useState } from "react";
import { getRecords } from "./ApiCall";
import CustomSearch from "../Classes/CustomSearch"

function formatIndianAmount(amount) {
  if (typeof amount !== "number" || isNaN(amount)) return "0.00";

  if (amount >= 1_00_00_000) {
    return `${(amount / 1_00_00_000).toFixed(2)} Cr`;
  }

  if (amount >= 1_00_000) {
    return `${(amount / 1_00_000).toFixed(2)} Lakh`;
  }

  return amount.toFixed(2);
}
function getAvgPricePerSqft(config) {
  const area = config.CarpetArea || config.BuiltUpArea;
  if (!area || !config.Price) return "0";

  const value = Math.round(config.Price / area);
  return value.toLocaleString("en-IN");
}

function formatDaysAgo(dateString) {
  if (!dateString) return "";

  // Expected format: dd-MMM-yyyy (e.g. 12-Jan-2024)
  const parts = dateString.split("-");
  if (parts.length !== 3) return "";

  const [day, monthStr, year] = parts;

  const monthMap = {
    Jan: 0,
    Feb: 1,
    Mar: 2,
    Apr: 3,
    May: 4,
    Jun: 5,
    Jul: 6,
    Aug: 7,
    Sep: 8,
    Oct: 9,
    Nov: 10,
    Dec: 11,
  };

  const month = monthMap[monthStr];
  if (month === undefined) return "";

  const inputDate = new Date(Number(year), month, Number(day));

  if (isNaN(inputDate.getTime())) return "";

  // Reset time for accurate day comparison
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  inputDate.setHours(0, 0, 0, 0);

  const diffInMillis = today.getTime() - inputDate.getTime();
  const diffInDays = Math.floor(diffInMillis / (1000 * 60 * 60 * 24));

  if (diffInDays === 0) return "Today";
  if (diffInDays === 1) return "Yesterday";
  if (diffInDays >= 2) return `${diffInDays} days ago`;

  return "";
}

function decryptOtp(encryptedText) {
  if (!encryptedText) return null;

  // Match Kotlin getKeyBytes(): 16 bytes, UTF-8, padded/truncated
  const keyUtf8 = CryptoJS.enc.Utf8.parse(key.padEnd(16, "\0").slice(0, 16));

  const ivUtf8 = keyUtf8; // IV = key (same as Android)

  try {
    const decrypted = CryptoJS.AES.decrypt(
      { ciphertext: CryptoJS.enc.Base64.parse(encryptedText) },
      keyUtf8,
      {
        iv: ivUtf8,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7, // PKCS5 == PKCS7 for AES
      },
    );

    return decrypted.toString(CryptoJS.enc.Utf8);
  } catch (e) {
    console.error("OTP decrypt failed", e);
    return null;
  }
}
function removeSpecialCharacters(text) {
  return text.replace(/[^a-zA-Z0-9 .,()-]/g, "");
}

function buildFilterString(filterParams = {}) {
  const filters = [];

  if (filterParams?.budgetFrom || filterParams?.budgetTo) {
    const min = filterParams?.budgetFrom ? Number(filterParams.budgetFrom) : 1;
    const max = filterParams?.budgetTo
      ? Number(filterParams.budgetTo)
      : 999999999;

    filters.push(`'MinPrice':{$lte:${max}}, 'MaxPrice':{$gte:${min}}`);
  }

  if (filterParams?.CarpetAreaFrom || filterParams?.CarpetAreaTo) {
    const min = filterParams?.CarpetAreaFrom
      ? Number(filterParams.CarpetAreaFrom)
      : 1;
    const max = filterParams?.CarpetAreaTo
      ? Number(filterParams.CarpetAreaTo)
      : 999999999;

    filters.push(
      `'MinCarpetArea':{$lte:${max}}, 'MaxCarpetArea':{$gte:${min}}`,
    );
  }

  if (filterParams?.MinPrice || filterParams?.MaxPrice) {
    const min = filterParams?.MinPrice ? Number(filterParams.MinPrice) : 1;
    const max = filterParams?.MaxPrice
      ? Number(filterParams.MaxPrice)
      : 999999999;

    if (filterParams?.vertical == 3) {
      filters.push(
        `'R1_RoomType': { \$elemMatch: { 'Rent': { \$gte: ${min}, \$lte: ${max} } } }`,
      );
    } else if (filterParams?.vertical == 2) {
      filters.push(`'MonthlyRent':{\$gte:${min}, \$lte:${max}}`);
    } else if (filterParams?.vertical == 1) {
      filters.push(`'Price':{\$gte:${min}, \$lte:${max}}`);
    }
  }

  Object.entries(filterParams).forEach(([key, value]) => {
    if (value === null || value === undefined) return;
    if (Array.isArray(value) && value.length === 0) return;

    if (
      key === "budgetFrom" ||
      key === "budgetTo" ||
      key === "MinPrice" ||
      key === "MaxPrice" ||
      key === "CarpetAreaFrom" ||
      key === "CarpetAreaTo" ||
      key === "wishlist"
    )
      return;

    // 🔴 SPECIAL CASES (elemMatch)
    if (key === "societyAmenities") {
      filters.push(
        `'PropertyAmenities':{$elemMatch:{'PropertyAmenitiesID':{$in:[${value.join(
          ",",
        )}]}}}`,
      );
      return;
    }

    if (key === "propertyAmenities") {
      filters.push(
        `'UnitFurnishingtitle':{$elemMatch:{'UnitFurnishingID':{$in:[${value.join(
          ",",
        )}]}}}`,
      );
      return;
    }

    // 🟢 NORMAL ARRAY CASE
    if (Array.isArray(value)) {
      filters.push(`'${mapKey(key)}':{$in:[${value.join(",")}]}`);
      return;
    }

    // 🟢 SINGLE VALUE CASE
    filters.push(`'${mapKey(key)}':{$eq:${value}}`);
  });

  return filters.join(",");
}

function mapKey(key) {
  const map = {
    propertyTypeIds: "ChoosePropertyID",
    bhkTypeIds: "BHKID",
    cityIds: "CityID",
    localityIds: "LocalityID",
    areaIds: "SocietyID",
    societyIds: "SocietyID",
    societyAmenities: "PropertyAmenitiesID",
    propertyAmenities: "UnitFurnishingID",
    featured: "FeaturedID",
    my: "cByID",
    vertical: "VerticalID",
    propertyType: "PropertyTypeID",
    constructionStatusIds: "ConstructionStatusID",
    furnishingTypeIds: "FurnishID",
    PGisFor: "PgisforID",
    BestSuitedFor: "BestSuitedforID",
    SocietyTypeIds: "SocietyTypeID",

    projectStatusIds: "ProjectStatusID",
    status: "StatusID",

    devIds: "DeveloperID",
    postedBy: "PostedByID",
  };

  return map[key] || key;
}

function getDisplayPrice(prop) {
  // Buy (Residential / Commercial)
  if ([1, 2].includes(prop?.PropertyTypeID) && prop?.VerticalID === 1) {
    return `₹ ${formatIndianAmount(Number(prop.Price))}`;
  }

  // Rent (Residential / Commercial)
  if ([1, 2].includes(prop?.PropertyTypeID) && prop?.VerticalID === 2) {
    return `₹ ${formatIndianAmount(Number(prop?.MonthlyRent ?? 0))}`;
  }

  // VerticalID == 3 and PropertyTypeID == 1
  if (prop?.PropertyTypeID === 1 && prop?.VerticalID === 3) {
    return `₹ ${rentRangeString(prop?.R1_RoomType)}`;
  }

  // Default (PG / Room type)
  return `₹ ${formatIndianAmount(Number(prop?.Price))}`;
}

function rentRangeString(roomTypes) {
  const rents = Array.isArray(roomTypes)
    ? roomTypes
        .map((rt) => parseNumberSafe(rt.Rent))
        .filter((v) => v !== null && v !== undefined)
    : [];

  if (rents.length === 0) return "";

  const min = Math.min(...rents);
  const max = Math.max(...rents);

  const minStr = Number.isInteger(min) ? String(min) : String(min);
  const maxStr = Number.isInteger(max) ? String(max) : String(max);

  return min === max ? minStr : `${minStr} - ${maxStr}`;
}

function parseNumberSafe(value) {
  if (value === null || value === undefined) return null;

  // If already a number
  if (typeof value === "number") {
    return isNaN(value) ? null : value;
  }

  // Convert everything else to string
  const s = String(value).trim();
  if (!s || s.toLowerCase() === "null") return null;

  // Remove non-digits except dot
  const digitsOnly = s.replace(/[^0-9.]/g, "");
  if (!digitsOnly) return null;

  const num = Number(digitsOnly);
  return isNaN(num) ? null : num;
}

function getUserLocation(onSuccess, onError) {
  if (!navigator.geolocation) {
    onError?.("Geolocation is not supported by this browser.");
    return;
  }

  navigator.geolocation.getCurrentPosition(
    (position) => {
      const { latitude, longitude } = position.coords;
      onSuccess({ latitude, longitude });
    },
    (error) => {
      onError?.(error.message);
    },
    {
      enableHighAccuracy: true,
      timeout: 10000,
      maximumAge: 0,
    },
  );
}

function generate4DigitId() {
  return Math.floor(1000 + Math.random() * 9000);
}

function getWishList() {
  const wishlist = localStorage.getItem("wishlist-landpanda");
  return wishlist ? JSON.parse(wishlist) : [];
}

function addtoWishlist(property, wishlist, setWishlist) {
  const tabID_ =
    property?.PropertyTypeID === 1 && property?.VerticalID === 1
      ? 384
      : property?.PropertyTypeID === 1 && property?.VerticalID === 2
        ? 385
        : property?.PropertyTypeID === 1 && property?.VerticalID === 3
          ? 386
          : property?.PropertyTypeID === 2 && property?.VerticalID === 1
            ? 387
            : 388;

  const data = {
    TabID: tabID_,
    ListingID: property?.ListingID,
    VerticalID: property?.VerticalID,
    PropertyTypeID: property?.PropertyTypeID,
  };

  let updatedWishlist = [...wishlist];

  const index = updatedWishlist.findIndex(
    (item) =>
      item.ListingID === data.ListingID &&
      item.VerticalID === data.VerticalID &&
      item.PropertyTypeID === data.PropertyTypeID,
  );

  if (index > -1) {
    updatedWishlist.splice(index, 1); // remove
  } else {
    updatedWishlist.push(data); // add
  }

  setWishlist(updatedWishlist);
  localStorage.setItem("wishlist-landpanda", JSON.stringify(updatedWishlist));
}

const getSearchData = (
  searchData,
  setsearchData,
  CityData,
  setCityData,
  Locality,
  setLocality,
  Area,
  setArea,
  Projects,
  setProjects,
  coordinates = null,
) => {
  const filter =
    coordinates != null
      ? `{'Coordinates': {'\$nearSphere': {'\$geometry': {'type':'Point','coordinates':[${coordinates?.longitude}, ${coordinates?.latitude}]}, '\$maxDistance': 30000000}}}`
      : `{}`;
  getRecords(260, 1008, filter, 1, "", (data) => {
    if (data != null) {
      if (data?.hasErrors === false) {
        setCityData(data?.response?.records || []);

        const mappedData = data?.response?.records?.map((item, index) => {
          return new CustomSearch({
            ResultName: item.City,
            ResultID: item?.CityID ?? null,
            CityID: item?.CityID ?? null,
            LocalityID: null,
            SocietyID: null,
            AreaID: null,
            flag: 1,
          });
        });

        setsearchData((prev) => [...prev, ...mappedData]);

        getRecords(383, 1008, `{}`, 1, "", (data) => {
          if (data != null) {
            if (data?.hasErrors === false) {
              setLocality(data?.response?.records || []);

              const mappedData = data?.response?.records?.map((item, index) => {
                return new CustomSearch({
                  ResultName: item.Locality,
                  ResultID: item?.LocalityID ?? null,
                  CityID: item?.CityID ?? null,
                  LocalityID: item?.LocalityID ?? null,
                  SocietyID: null,
                  AreaID: null,
                  flag: 2,
                });
              });

              setsearchData((prev) => [...prev, ...mappedData]);

              getRecords(424, 1008, `{}`, 1, "", (data) => {
                if (data != null) {
                  if (data?.hasErrors === false) {
                    setArea(data?.response?.records || []);
                    const mappedData = data?.response?.records?.map(
                      (item, index) => {
                        return new CustomSearch({
                          ResultName: item.SubArea,
                          ResultID: item?.SubAreaID ?? null,
                          CityID: item?.CityID ?? null,
                          LocalityID: item?.LocalityID ?? null,
                          SocietyID: null,
                          AreaID: item?.SubAreaID ?? null,
                          flag: 4,
                        });
                      },
                    );

                    setsearchData((prev) => [...prev, ...mappedData]);

                    getRecords(
                      398,
                      1008,
                      `{StatusID: { $in: [${2}] }}`,
                      1,
                      "",
                      (data) => {
                        if (data != null) {
                          if (data?.hasErrors === false) {
                            setProjects(data?.response?.records || []);
                            const mappedData = data?.response?.records?.map(
                              (item, index) => {
                                return new CustomSearch({
                                  ResultName: item.Society,
                                  ResultID: item?.SocietyID ?? null,
                                  CityID: item?.CityID ?? null,
                                  LocalityID: item?.LocalityID ?? null,
                                  SocietyID: item?.SocietyID ?? null,
                                  AreaID: item?.SubAreaID ?? null,
                                  flag: 3,
                                });
                              },
                            );
                            setsearchData((prev) => [...prev, ...mappedData]);
                          } else {
                            console.log(
                              "Error in fetching featured properties",
                              data,
                            );
                          }
                        }
                      },
                    );
                  } else {
                    console.log("Error in fetching featured properties", data);
                  }
                }
              });
            } else {
              console.log("Error in fetching featured properties", data);
            }
          }
        });
      } else {
        console.log("Error in fetching featured properties", data);
      }
    }
  });
};

export {
  formatIndianAmount,
  formatDaysAgo,
  decryptOtp,
  buildFilterString,
  getDisplayPrice,
  getUserLocation,
  getAvgPricePerSqft,
  generate4DigitId,
  removeSpecialCharacters,
  getWishList,
  addtoWishlist,
  getSearchData,
};
